import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Link,
  Typography,
} from "@material-ui/core";

interface InventoryPurchaseInfoDialogProps {
  open: boolean;
  onAcknowledge: () => void;
}

const InventoryPurchaseInfoDialog: React.FC<
  InventoryPurchaseInfoDialogProps
> = ({ open, onAcknowledge }) => {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>Update Purchase Information</DialogTitle>
      <DialogContent>
        <Typography gutterBottom>
          In order to accurately calculate your inventory, My Reseller Genie
          needs the <strong>purchase date</strong> and{" "}
          <strong>purchase price</strong> for all of your current inventory and
          sales (sold inventory).
        </Typography>
        <Typography>
          Please make sure to update these fields for your existing records if
          you are using the{" "}
          <Link
            href="https://support.myresellergenie.com/hc/en-us/articles/14483257510427-What-is-the-difference-between-the-cash-inventory-method-and-the-accrual-inventory-method"
            target="_blank"
            rel="noopener noreferrer"
          >
            accrual inventory method
          </Link>
          . This will ensure your inventory balances and cost of goods sold are
          calculated correctly.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onAcknowledge}
          variant="contained"
          color="primary"
          autoFocus
        >
          I Understand
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InventoryPurchaseInfoDialog;
